interface PublicLayoutProps {
  children: React.ReactNode;
}

export const PublicLayout = ({ children }: PublicLayoutProps) => (
  <div className="min-h-screen flex flex-col">
    {children}
  </div>
);